import { ErrorBoundary } from "../ErrorBoundary";
import AsyncSelect from "react-select/async";

import { useCallback, useEffect, useRef } from 'react';
function debounce(fn, delay = 250) {
  let timeout;
  return (...args) => {
    clearTimeout(timeout);
    timeout = setTimeout(() => {
      fn(...args);
    }, delay);
  };
}

export const AutoComplete = ({
  getList,
  parentValue,
  setParentValue,
  placeholder = "",
  noBorderRadius = false,
  required = false,
  isDisabled = false,
  isMultiselect = false,
  noFilterSuggested = false,
    esDocumento = false
}) => {
  const selectRef = useRef();

  useEffect(() => {
    if (selectRef && parentValue) {
      selectRef.current?.setValue(parentValue);
    }
  }, [parentValue]);
  
  useEffect(() => {
    var inputs = document.querySelectorAll(`.react-select__input`);
    if (inputs) {
      inputs.forEach((input) => {
        input.style.width = "200px";
      });
    }
  }, []);
  const fetchOptions = async (inputValue) => {
    if (inputValue) {
      let suggestions = await getList(inputValue);
      if (noFilterSuggested) {
        return suggestions;
      }
      return suggestions.filter((i) =>
        i.label.toLowerCase().includes(inputValue.toLowerCase())
      );
    } else {
      return [];
    }
  };

  const loadOptionsDebounced = useCallback(
    debounce((inputValue, callback) => {
      fetchOptions(inputValue).then((options) => {
        if(esDocumento){
          options.push({label: inputValue, value: inputValue})
        }
        callback(options)
      });
    }, 500),
    [getList]
  );

  const onChange = (option) => {
    try {
      if (option === parentValue) {
        return;
      }
      if(esDocumento){
        option.label = option.label.split(" / ")[0];
      }
      if (isMultiselect) {
        setParentValue(option ? option : null);
      } else {
        setParentValue(option ? option : null);
      }
    } catch (error) {
      console.dev(error);
    }
  };

  const customStyles = {
    menu: (provided, state) => ({
      ...provided,
      zIndex: 9999,
    }),
    control: (provided, state) => ({
      ...provided,
      borderLeft: required ? "3px solid red" : "",
    }),
    input: (provided, state) => ({
      ...provided,
      width: "200px",
    }),
  };
  
  return (
      <AsyncSelect
        ref={selectRef}
        className="react-select-container"
        classNamePrefix="react-select"
        isClearable
        styles={customStyles}
        isMulti={isMultiselect}
        loadOptions={loadOptionsDebounced}
        onChange={onChange}
        placeholder={placeholder}
        isDisabled={isDisabled}
        required={required}
        components={{
          DropdownIndicator: () => null,
          IndicatorSeparator: () => null,
        }}
      />
  );
};
